import { stringifyQuery } from '../utils/query'
import { getApiVersion, http } from '../utils/domain'

// import {
//   buildQueries,
// } from '../utils/transformers'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}`
}

export const fetchAreaData = (appId) => {
  return http()
    .post(`${prefix(appId)}/getTablesByTag?tag=AREA`, {
      returnSlugs: [
        'title',
        'parentId',
        'isDisableNode',
        'level',
        'isParentNode',
        'bindUsers',
        'lnglat',
      ],
      order: {
        desc: false,
        slug: 'childOrder',
      },
    })
    .json()
    .catch(() => {
      console.warn('[api] cant load area')
      return []
    })
}

export const fetchAreaDataByLevelAndField = (appId, fields = [], level = 1) => {
  return http()
    .post(`${prefix(appId)}/getTablesByTag?tag=AREA`, {
      returnSlugs: ['title', 'level', ...fields],
      childQueries: [
        {
          yacQueryOperate: {
            operator: 'equal',
            left: {
              slug: 'level',
            },
            right: {
              value: level,
            },
          },
        },
      ],
    })
    .json()
    .catch(() => {
      console.warn('[api] cant load area')
      return []
    })
}

// 获取点位
export const fetchAreaDataNew = (appId, tbId) => {
  return http()
    .post(`${prefix(appId)}/tbs/${tbId}/fields/parentId/cascadeTree`, [])
    .json()
    .catch(() => {
      console.warn('[api] cant load area')
      return []
    })
}

// 批量添加点位或指标
export const createBatchAreas = (appId, tbId, tag, parentId, title) => {
  return http()
    .post(
      `${prefix(
        appId
      )}/tbs/${tbId}/addBatchStandardOrArea?tag=${tag}&parentId=${parentId}`,
      title
    )
    .json()
}

// 删除点位或指标
export const destroyAreas = (appId, tbId, tag, objectId) => {
  return http()
    .delete(
      `${prefix(
        appId
      )}/tbs/${tbId}/deleteStandardOrAreaNode?tag=${tag}&objectId=${objectId}`,
      null,
      { throwHttpErrors: false }
    )
    .json()
}

// 批量删除点位或指标
export const destroyBatchAreas = (appId, tbId, tag, objectIds) => {
  return http()
    .delete(
      `${prefix(appId)}/tbs/${tbId}/batchDeleteStandardOrAreaNode?tag=${tag}`,
      objectIds,
      { throwHttpErrors: false }
    )
    .json()
}

// 编辑点位或指标
export const updateAreas = (appId, tbId, tag, objectId, title) => {
  return http()
    .put(
      `${prefix(
        appId
      )}/tbs/${tbId}/editStandardOrAreaNode?tag=${tag}&objectId=${objectId}`,
      { title }
    )
    .json()
}

/**
 * @deprecated
 * 获取全部级联数据
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} slug 父级Id所在字段
 * @param {*} parentSlug 可选，父级id所引用的字段 默认 _id
 * @param {*} byChildOrder 可选，是否根据根据子节点顺序排序 默认true
 * @param {*} obtainDisableNode 可选，是否获取禁用节点 默认true
 * @returns
 */
export const fetchCascadeTreeData = (
  appId,
  tbId,
  slug,
  parentSlug = '_id',
  byChildOrder = true,
  obtainDisableNode = true
) => {
  const params = {
    parentSlug,
    byChildOrder,
    obtainDisableNode,
  }
  return http()
    .post(
      `${prefix(appId)}/tbs/${tbId}/fields/${slug}/cascadeTree${stringifyQuery({
        ...params,
      })}`
    )
    .json()
    .catch(() => {
      console.warn('[api] cant load treeData')
      return []
    })
}

/**
 * 修改节点顺序
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectList 点位对象列表 eg. {object1: 1, object2: 4}
 * @returns
 */
export const updateAreaNodeOrder = (appId, tbId, objectList) => {
  return http()
    .put(
      `${prefix(appId)}/tbs/${tbId}/editStandardOrAreaNodeOrder${stringifyQuery(
        {
          tag: 'AREA',
        }
      )}`,
      objectList
    )
    .json()
}

/**
 * 添加多级指标或点位的预览
 * @param {*} appId 项目Id
 * @param {*} strList 多级点位列表
 * @returns
 */
export const fetchPreviewTree = (appId, strList) => {
  return http()
    .post(`${prefix(appId)}/tbs/previewTree`, strList)
    .json()
    .catch(() => {
      console.warn('[api] cant load PreviewTree')
      return []
    })
}

/**
 * 添加多级点位
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} parentId 可选，默认不传parentId视为从一级开始添加
 * @param {*} strList 多级点位列表
 * @returns
 */
export const createNestedArea = (appId, tbId, parentId, strList) => {
  return http()
    .post(
      `${prefix(appId)}/tbs/${tbId}/addMultistageStandardOrArea${stringifyQuery(
        {
          parentId,
          tag: 'AREA',
        }
      )}`,
      strList
    )
    .json()
}

/**
 * 删除点位
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 要删除的数据id
 * @returns
 */
export const destroyAreaNode = (appId, tbId, objectId) => {
  return http().delete(
    `${prefix(appId)}/tbs/${tbId}/deleteStandardOrAreaNode${stringifyQuery({
      objectId,
      tag: 'AREA',
    })}`,
    null,
    {
      throwHttpErrors: true,
    }
  )
}

/**
 * @deprecated
 * 修改点位
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 要修改的数据id
 * @param {*} changedValues 要修改的数据
 * @returns
 */
export const updateAreaNode = (appId, tbId, item) => {
  return http()
    .put(
      `${prefix(
        appId
      )}/tbs/${tbId}/tbs/{tbId}/editStandardOrAreaNode${stringifyQuery({
        objectId: item.objectId,
        tag: 'AREA',
      })}`,
      item
    )
    .json()
}

/**
 * 添加或者更新表单绑定规则
 * @param {*} params
 * @param {number} params.id
 * @param {string} params.name
 * @param {number} params.appId
 * @param {string} params.bindType tableValue_tableSlug
 * @param {number} params.leaderId 被绑定者表单id
 * @param {number} params.started 是否启用默认值FALSE
 * @returns
 */
export const createBindRules = (params) => {
  return http().post(`${getApiVersion()}/apps/bindRules`, params).json()
}

/**
 * 获取表单规则分页列表
 * @param {*} params
 * @param {*} params.appId 项目Id
 * @param {*} params.leaderId 当前表单id
 * @param {*} params.page 第几页
 * @param {*} params.size 每页显示多少数据
 * @returns
 */
export const fetchBindRules = (params) => {
  return http()
    .get(`${getApiVersion()}/apps/bindRules/page${stringifyQuery(params)}`)
    .json()
}

/**
 * 添加表单绑定规则节点
 * @param {*} nodes
 * @returns
 */
export const bindRuleNodes = (nodes) => {
  return http()
    .post(`${getApiVersion()}/apps/bindRules/bindRuleNodes`, nodes)
    .json()
}

/**
 * 获取表单绑定节点列表
 * @param {*} params
 * @param {*} params.bindRuleId 规则id
 * @returns
 */
export const fetchBindNodeRuleList = (params) => {
  return http()
    .get(
      `${getApiVersion()}/apps/bindRules/bindNodeRuleList${stringifyQuery(
        params
      )}`
    )
    .json()
}

/**
 * 批量删除表单绑定节点
 * @param {number[]} ids
 * @returns
 */
export const destoryNodeRule = (ids) => {
  return http()
    .delete(`${getApiVersion()}/apps/bindRules/bindRuleNodes`, ids)
    .json()
}

/**
 * 获取规则下绑定的objectId
 * @param {*} appId 项目Id
 * @param {*} ruleId 规则Id
 * @returns
 */
export const fetchRuleObjectList = (appId, ruleId) => {
  return http()
    .get(`${prefix(appId)}/dataUserBindingRule/${ruleId}/all`)
    .json()
}

/**
 * 新建点位绑定用户规则
 * @param {*} appId 项目Id
 * @param {*} ruleName 规则名称
 * @param {*} tbId 当前表单id
 * @param {*} targetTbId 要绑定的表单id
 * @returns
 */
export const createBindUserRule = (appId, tbId, ruleName, targetTbId) => {
  return http()
    .post(
      `${prefix(appId)}/dataUserBindingRule/${tbId}${stringifyQuery({
        ruleName,
        targetTbId,
      })}`,
      {}
    )
    .json()
}

/**
 * 查询点位绑定用户规则列表
 * @param {*} appId 项目Id
 * @param {*} tbId 当前表单id
 * @param {*} targetTbId 要绑定的表单id
 * @param {*} page 第几页
 * @param {*} size 每页显示多少数据
 * @returns
 */
export const fetchBindUserRule = (appId, tbId, targetTbId, page, size) => {
  return http()
    .get(
      `${prefix(appId)}/dataUserBindingRule/${tbId}${stringifyQuery({
        page,
        size,
        targetTbId,
      })}`,
      {}
    )
    .json()
}

/**
 * 启用/关闭点位绑定用户规则
 * @param {*} appId 项目Id
 * @param {*} ruleId 规则Id
 * @param {boolean} enable 开启关闭
 * @returns
 */
export const switchBindUserRule = (appId, ruleId, enable) => {
  return http()
    .put(
      `${prefix(appId)}/dataUserBindingRule/${ruleId}${stringifyQuery({
        enable,
      })}`
    )
    .json()
}

/**
 * 新增或修改绑定
 * @param {*} appId 项目Id
 * @param {*} ruleId 规则Id
 * @param {*} objectId 绑定对象id
 * @param {number[]} userIds 要绑定的用户id
 * @returns
 */
export const bindRuleUserList = (appId, ruleId, objectId, userIds) => {
  return http()
    .put(
      `${prefix(appId)}/dataUserBindingRule/${ruleId}/data${stringifyQuery({
        objectId,
      })}`,
      userIds
    )
    .json()
}

/**
 * 批量添加绑定
 * @param {*} appId 项目Id
 * @param {*} ruleId 规则Id
 * @param {*} configMap { [objectId]: userIds }
 * @returns
 */
export const batchBindRuleUserList = (appId, ruleId, configMap) => {
  return http()
    .put(
      `${prefix(appId)}/dataUserBindingRule/${ruleId}/data/batch?isDelete=true`,
      configMap
    )
    .json()
}

/**
 * 获取规则下某个objectId绑定的用户
 * @param {*} appId 项目Id
 * @param {*} ruleId 规则Id
 * @param {*} objectId 绑定对象id
 * @returns
 */
export const fetchRuleObjectUserList = (appId, ruleId, objectId) => {
  return http()
    .get(
      `${prefix(appId)}/dataUserBindingRule/${ruleId}/user${stringifyQuery({
        objectId,
      })}`
    )
    .json()
}

/**
 * 清除点位缓存
 * @param {*} appId 项目Id
 * @returns
 */
export const cleanAreaCache = (appId) => {
  return http().get(`${prefix(appId)}/getTablesByTag/cleanAll?tag=AREA`)
}

/**
 * 获取指标点位长度的接口
 * @param {*} appId 项目Id
 * @returns
 */
export const fetchTreeHeight = (appId) => {
  return http()
    .get(`${prefix(appId)}/treeTable/treeHeight`)
    .json()
}

/**
 * 节点启用禁用
 * @param {*} appId
 * @param {*} tbId
 * @param {*} objectId
 * @param {*} disable
 * @returns
 */
export const toggleNodeEnabled = (appId, tbId, objectId, disable) => {
  return http().put(
    `${prefix(appId)}/tbs/${tbId}/cascadeTree/disableNode${stringifyQuery({
      tag: 'AREA',
      objectId,
      disable,
    })}`
  )
}

/**
 * 获取绑定信息
 * @param {*} appId
 * @param {*} tbId
 * @returns
 */
export const fetchFieldBindingTable = (appId, tbId) => {
  return http()
    .get(`${prefix(appId)}/fieldBindingTable?tbId=${tbId}`)
    .json()
}

/**
 * 导出点位
 * @param {*} appId
 * @param {boolean} obtainDisableNode 是否获取禁用点位
 * @param {boolean} excludeUsed 是否排除上报过的点位
 * @returns
 */
export const getExportAreaUrl = (appId, obtainDisableNode, excludeUsed) => {
  return http()
    .get(
      `${prefix(appId)}/tbs/exportAreaTreeDaPing${stringifyQuery({
        obtainDisableNode,
        excludeUsed,
      })}`
    )
    .json()
}
